export const getLocalStorageItem = <T>(key: string): T | null => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

export const setLocalStorageItem = <T>(key: string, data: T) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const cleanLocalStorageItem = (key: string) => {
  localStorage.removeItem(key);
};
export const cleanAllLocalStorage = () => {
  localStorage.clear();
};
